<template>
  <v-container grid-list-md text-center v-if="isConfigLoaded">
    <v-card class="mx-auto" elevation="0">
      <h2 class="text-xs-center">
        {{ this.getConfigItem("INPUTUSERINFO_TITLE_01") }}
      </h2>
      <br />
      <h4 class="text-xs-center">
        {{ this.getConfigItem("INPUTUSERINFO_TITLE_02") }}
      </h4>
      <br />
      <v-form
        ref="userInfoForm"
        v-model="isFormValid"
        @submit.prevent="saveUserInfo()"
        lazy-validation
      >
        <v-text-field
          v-if="!this.REQUIRES_AUTHENTICATION && this.STUDENTID_ISREQUIRED"
          ref="studentIdField"
          v-model="inputStudentId"
          type="text"
          class="mx-8"
          :label="this.getConfigItem('PHOLDER_STUDENTID_TEXT')"
          :required="this.STUDENTID_ISREQUIRED"
          :rules="studentIdRules"
          :hint="this.getConfigItem('STUDENTID_HINT_TEXT')"
        ></v-text-field>
        <v-text-field
          ref="phonenumField"
          v-if="this.MOBILENUM_ISREQUIRED"
          v-model="inputPhonenum"
          type="text"
          class="mx-8"
          :label="this.getConfigItem('PHOLDER_MOBILE_TEXT')"
          :required="this.MOBILENUM_ISREQUIRED"
          :rules="phonenumRules"
          :hint="this.getConfigItem('MOBILENUM_HINT_TEXT')"
        ></v-text-field>
      </v-form>
      <v-container class="text--left">
        <v-form
          v-if="ENABLE_CAPTCHA"
          ref="captchaForm"
          v-model="isCaptchaFormValid"
          @submit.prevent="saveUserInfo()"
          lazy-validation
          class="mx-1"
        >
          <canvas
            ref="captchaCanvas"
            width="95"
            height="35"
            style="display: none"
          ></canvas>
          <v-text-field
            ref="captchaInputField"
            clearable
            v-model="captchaInput"
            :label="this.getConfigItem('PHOLDER_CAPTCHA_TEXT')"
            required
            type="text"
            :rules="captchaRules"
            class="override-prepend-outer"
            style="padding-top: 4px"
            :hint="this.getConfigItem('CAPTCHA_INFO_TEXT')"
            persistent-hint
          >
            <div slot="prepend" style="margin-top: -12px">
              <span style="word-break: keep-all; white-space: nowrap">
                <img
                  v-bind:src="captchaImageUrl"
                  style="vertical-align: middle"
                />
                <v-btn
                  text
                  icon
                  color="primary"
                  :style="{ color: PRIMARY_COLOUR_TEXT }"
                  @click="generateCaptcha()"
                  style="margin-right: 0px"
                  title="New Captcha code"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
                <v-btn
                  text
                  icon
                  color="primary"
                  :style="{ color: PRIMARY_COLOUR_TEXT }"
                  @click="playCaptcha(captchaString1 + captchaString2)"
                  style="margin-left: 0px"
                  title="Listen to the Captcha code"
                >
                  <v-icon>mdi-volume-high</v-icon>
                </v-btn>
              </span>
            </div>
          </v-text-field>
        </v-form>
      </v-container>

      <h4 class="text-xs-center">
        {{ this.getConfigItem("INPUTUSERINFO_TITLE_03") }}
      </h4>
      <br />
      <h5 class="text-xs-left">
        {{ this.getConfigItem("INPUTUSERINFO_FOOTER_01") }}
      </h5>
      <br />
      <v-row row wrap>
        <v-col xs12 class="text-xs-center">
          <v-btn
            tile
            @click="saveUserInfo(false)"
            color="primary"
            :style="{ color: PRIMARY_COLOUR_TEXT }"
            >{{ this.getConfigItem("BTN_NEXT_TEXT") }}</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="this.SHOW_NO_STUDENT_ID_BUTTON" row wrap>
        <v-col xs12 class="text-xs-center">
          <v-btn
            tile
            color="secondary"
            :style="{ color: SECONDARY_COLOUR_TEXT }"
            @click="saveUserInfo(true)"
            >{{ this.getConfigItem("BTN_NO_STUDENTID_TEXT") }}</v-btn
          >
        </v-col>
      </v-row>
      <input
        ref="password"
        type="input"
        id="password"
        name="password"
        value
        style="display: none !important"
        tabindex="-1"
        autocomplete="off"
      />
    </v-card>
  </v-container>
</template>

<script>
// import { helper } from "@/helper";
import configAliasMixin from "@/mixins/configAliasMixin";
import cookieMixin from "@/mixins/cookieMixin";
import { mapGetters } from "vuex";
import { helper } from "@/helper";
import store from "@/store";

export default {
  mixins: [configAliasMixin, cookieMixin],
  watch: {
    isConfigLoaded() {
      if (this.isConfigLoaded) {
        this.loadConfig();
      }
    },
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    isCaptchaValid() {
      return (
        this.captchaInput !== "" &&
        this.captchaString1 + this.captchaString2 ===
          this.captchaInput.toLowerCase()
      );
    },
    ENABLE_CAPTCHA() {
      return this.getConfigItem("ENABLE_CAPTCHA", true);
    },
    MOBILENUM_ISREQUIRED() {
      return this.getConfigItem("MOBILENUM_ISREQUIRED", true);
    },
    STUDENTID_ISREQUIRED() {
      return this.getConfigItem("STUDENTID_ISREQUIRED", true);
    },
    REQUIRES_AUTHENTICATION() {
      return this.getConfigItem("REQUIRES_AUTHENTICATION", true);
    },
    SHOW_NO_STUDENT_ID_BUTTON() {
      return this.getConfigItem("SHOW_NO_STUDENT_ID_BUTTON", true);
    },
  },
  data: () => ({
    isFormValid: false,
    isCaptchaFormValid: false,
    studentIdRules: [],
    nameRules: [],
    inputStudentId: "",
    inputPhonenum: "",
    phonenumRules: [],
    captchaRules: [],
    noStudentId: false,

    captchaImageUrl: "",
    captchaString1: "",
    captchaString2: "",
    captchaInput: "",
    withoutStudentId: false,

    checkbox: false,
  }),
  created: function () {},
  beforeRouteEnter: (to, from, next) => {
    const userCookie = helper.getUserCookie();

    let requireAuthentication = store.getters.getConfigItem(
      "REQUIRES_AUTHENTICATION",
      true
    );

    if (process.env.VUE_APP_ISDEBUGGING)
      console.log(
        "Home - beforeRouteEnter - REQUIRES_AUTHENTICATION",
        requireAuthentication
      );

    if (requireAuthentication && userCookie == null) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log(
          "requireAuthentication: " +
            requireAuthentication +
            " userCookie:" +
            userCookie
        );
      window.location.replace(store.getters.getConfigItem("AUTH_URL"));
      return;
    }
    next();
  },
  mounted: function () {
    //also in Watch.isConfigLoaded()
    if (this.isConfigLoaded) {
      this.loadConfig();
    }
  },
  methods: {
    loadConfig() {
      if (this.getConfigItem("ENABLE_CAPTCHA")) {
        this.generateCaptcha();
      }

      this.inputStudentId = this.studentId; //from cookie
      this.inputPhonenum = this.phonenum; // from cookie
      // load rules for Student Num:

      const studentNumRegexString = this.getConfigItem("STUDENT_NUMBER_REGEX");
      const studentNumRegex = new RegExp(studentNumRegexString, "i");

      this.isCaptchaFormValid = !this.ENABLE_CAPTCHA;
      this.nameRules = [
        (v) => !!v || this.getConfigItem("NAME_REQUIRED_TEXT"),
        (v) =>
          (v && v.length <= 10) || this.getConfigItem("NAME_MUST_LESS_TEXT"),
      ];
      this.captchaRules = [(v) => !!v || this.getConfigItem("REQUIRED_TEXT")];

      if (this.STUDENTID_ISREQUIRED) {
        // if the "I don't have a student id" button is pressed, then it'll skip these rules
        this.studentIdRules.push((v) => {
          if (this.withoutStudentId) {
            return true;
          } else {
            return !!v || this.getConfigItem("REQUIRED_TEXT");
          }
        });

        // if the "I don't have a student id" button is pressed, it'll ignore this rule,
        // if the person hasn't entered anything in the student id field
        if (studentNumRegexString != "") {
          this.studentIdRules.push((v) => {
            if (this.withoutStudentId && (v == null || v == "")) {
              return true;
            } else {
              return (
                studentNumRegex.test(v) ||
                this.getConfigItem("STD_NUMBER_ERROR_TEXT")
              );
            }
          });
        }
      } else {
        //this rule only evaluates the other rules if the input is not blank:
        if (studentNumRegexString != "") {
          this.studentIdRules.push((v) => {
            if (v == "") {
              return true;
            } else {
              return (
                studentNumRegex.test(v) ||
                this.getConfigItem("STD_NUMBER_ERROR_TEXT")
              );
            }
          });
        }
      }

      // load rules for Mobile Num:
      const phv_mustStartRule = (v) =>
        /^04/.test(v) || this.getConfigItem("PHONE_MUST_START_TEXT");
      const phv_mustEqualRule = (v) =>
        (v || "").length >= 10 || this.getConfigItem("PHONE_MUST_EQUAL_TEXT");
      const phv_maxNumberRule = (v) =>
        /^\d{1,10}$/.test(v) || this.getConfigItem("PHONE_MAX_NUMBER_TEXT");

      if (this.MOBILENUM_ISREQUIRED) {
        this.phonenumRules.push(
          (v) => !!v || this.getConfigItem("REQUIRED_TEXT")
        );
        this.phonenumRules.push(phv_mustStartRule);
        this.phonenumRules.push(phv_mustEqualRule);
        this.phonenumRules.push(phv_maxNumberRule);
      } else {
        //this rule only evaluates the other rules if the input is not blank:
        this.phonenumRules.push((v) => {
          var phv_nonBlankRules = [];
          phv_nonBlankRules.push(phv_mustStartRule);
          phv_nonBlankRules.push(phv_mustEqualRule);
          phv_nonBlankRules.push(phv_maxNumberRule);

          if (v == "") {
            return true;
          } else {
            for (let index = 0; index < phv_nonBlankRules.length; index++) {
              const rule = phv_nonBlankRules[index];
              if (typeof rule(v) === "string") return rule(v);
            }
            return true;
          }
        });
      }
    },
    generateCaptcha() {
      if (!this.ENABLE_CAPTCHA) return;
      var captcha = this.createCaptcha(this.$refs.captchaCanvas);
      this.captchaImageUrl = captcha.captchaImageUrl;
      this.captchaString1 = captcha.captchaString.substring(0, 3).toLowerCase();
      this.captchaString2 = captcha.captchaString.substring(3, 6).toLowerCase();
    },
    saveUserInfo(withoutStudentId) {
      this.withoutStudentId = withoutStudentId;
      // Additional Honeypot for bots:
      if (this.$refs.password.value !== "") {
        if (process.env.VUE_APP_ISDEBUGGING)
          console.log("%c honeypot filled, cannot proceed", "color:plum");
        return;
      }

      let that = this;

      if (!that.$refs.userInfoForm.validate()) {
        if (process.env.VUE_APP_ISDEBUGGING)
          console.log("invalid userInfoForm");
        return;
      }

      that.$refs.userInfoForm.resetValidation();

      if (this.ENABLE_CAPTCHA) that.$refs.captchaForm.resetValidation();

      if (!withoutStudentId) that.$refs.userInfoForm.validate();

      if (this.ENABLE_CAPTCHA) that.$refs.captchaForm.validate();

      if (
        this.ENABLE_CAPTCHA &&
        (!that.isCaptchaFormValid || !that.isCaptchaValid)
      ) {
        this.captchaInput = "";
        this.generateCaptcha();
        that.$root.showError(
          "Captcha incorrect",
          "Captcha entered was incorrect."
        );
        return;
      }
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("isFormValid: " + that.isFormValid);

      if (!withoutStudentId && !that.isFormValid) return;

      // Save items to the userCookie:

      let userCookie = helper.getUserCookie();

      if (!userCookie) userCookie = {};

      userCookie.mobile = that.inputPhonenum;

      if (!this.REQUIRES_AUTHENTICATION) {
        if (withoutStudentId) {
          userCookie.withoutStudentId = true;
        }
        userCookie.userName = that.inputStudentId;
      } else {
        userCookie.withoutStudentId = true;
      }

      helper.setUserCookie(
        userCookie,
        this.getConfigItem("DATA_RETENTION_PERIOD")
      );
      that.$router.push("/");
    },
    createCaptcha(captchaCanvas) {
      var captchaString = "";
      let captchaLength = 6;
      let chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      for (var i = 0; i < captchaLength; i++) {
        captchaString += chars[Math.floor(Math.random() * chars.length)];
      }

      let canvasContext = captchaCanvas.getContext("2d");
      canvasContext.clearRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      canvasContext.font = "13pt Calibri";
      canvasContext.textAlign = "center";
      canvasContext.fillText(captchaString, captchaCanvas.width / 2, 23);

      return {
        captchaImageUrl: canvasContext.canvas.toDataURL(),
        captchaString: captchaString,
      };
    },
    playCaptcha(captchaString) {
      let letter = captchaString[0];
      let audioPath = process.env.BASE_URL + "audio/" + letter + ".mp3";
      var audio = new Audio(audioPath);
      audio.style.display = "none";
      audio.autoplay = true;

      let that = this;
      audio.onended = function () {
        if (captchaString.length > 1)
          that.playCaptcha(captchaString.substring(1, captchaString.length));
      };
      audio.play();
    },
  },
};
</script>
